<td-wb-loading-indicator position="top"
                         [displayDelay]="0" />
